window.addEventListener("DOMContentLoaded", (event) => {
    const header = document.querySelector('#vue-header')
    if (header === null) {
        return;
    }
    const modal = document.querySelector('.js-video-modal')
   

    if(modal){
        const videoIframe = document.querySelector('.js-video-iframe')
        let currentUrl = videoIframe.src
        const closeBtns = [...document.querySelectorAll('.js-close-video-modal')]      
        const openBtns = [...document.querySelectorAll('.js-button-video')]      

        const closeModal = () => { modal.classList.add('hidden')}

        const openModal = () => {modal.classList.remove('hidden')}
        
        closeBtns.forEach(button => {
            button.addEventListener('click', (event) => {
                closeModal()
                videoIframe.src= ''
            })
        })

        openBtns.forEach(button => {
            button.addEventListener('click', (event) => {
                videoIframe.src= currentUrl
                openModal()
            })
        })
    
    }
})